// Тексты «Битвы с AI Claude Opus»: в главном меню — подписи кнопки, промо-модалка
// и отказы входа в лобби дня; в самом лобби — модалка зрителя и служебные тосты
// сокета. Название события — AI_MATCH_TITLE в configs/aiMatch.js (рядом с
// иконкой ИИ — короткое AI_MATCH_SHORT_TITLE)

// Отсчет до старта — на кнопке меню, в промо-модалке и в самом лобби (см.
// getAiPromoCountdown): до 21:00 — «Сбор игроков 5 мин 0 сек» (до самой 21:00),
// после, когда сервер взвел отсчет, — «Старт через 7 мин 5 сек»
export const TEXT_AI_MATCH_GATHERING_PREFIX = 'Сбор игроков';
export const TEXT_AI_MATCH_START_IN_PREFIX = 'Старт через';
export const TEXT_AI_MATCH_START_IN_MINUTES = 'мин';
export const TEXT_AI_MATCH_START_IN_SECONDS = 'сек';
// После 21:00 в пустом лобби отсчета нет: он взведется, когда войдет первый
// живой игрок (см. aiPromoStartTimer.js)
export const TEXT_AI_MATCH_WAITING_FIRST_PLAYER = 'Ждем первого игрока';
// Матч начался (или идут баны и выбор фракций): войти можно только зрителем
export const TEXT_AI_MATCH_WATCH = 'Смотреть матч';

export const TEXT_AI_MATCH_PROMO =
  'Скоро начнется матч против AI Claude Opus — одной из самых сильных языковых моделей от Anthropic. '
  + 'Присоединяйся и проверь свои стратегические навыки!';
// Подстроки TEXT_AI_MATCH_PROMO, подсвеченные цветом (см. splitTextByAccents)
export const TEXT_AI_MATCH_PROMO_ACCENTS = ['Claude Opus'];
export const TEXT_AI_MATCH_PROMO_JOIN = 'Присоединиться';

// Разовый анонс события в главном меню (AiMatchNewsModal): событие теперь
// ежедневное и открыто всем. Время старта подставляется по часам игрока и по
// Москве (getAiPromoOpensTimes); подсвечиваются имя модели и время
export const TEXT_AI_MATCH_NEWS_TITLE = 'Битва с AI Claude Opus — каждый день!';
export const TEXT_AI_MATCH_NEWS_INTRO =
  'Теперь каждый день все игроки могут помериться силами с настоящей топовой нейросетью — ';
export const TEXT_AI_MATCH_NEWS_MODEL = 'Claude Opus';
export const TEXT_AI_MATCH_NEWS_INTRO_END = ' от Anthropic.';
export const TEXT_AI_MATCH_NEWS_START_PREFIX = 'Матч начинается в';
export const TEXT_AI_MATCH_NEWS_MSK_SUFFIX = 'по Москве';
export const TEXT_AI_MATCH_NEWS_CALL =
  'Заходи в игру в это время — расскажем, как присоединиться!';
export const TEXT_AI_MATCH_NEWS_OK = 'Понятно';
// Тот же анонс для игрока, уже закрывшего прежнюю редакцию: время начала
// изменилось (см. aiMatchNewsVersion.js). Само время — в той же строке
// «Матч начинается в …», прежнее не называем: оно устарело бы при новом переносе
export const TEXT_AI_MATCH_NEWS_UPDATE_TITLE = 'Битва с AI Claude Opus — новое время!';
export const TEXT_AI_MATCH_NEWS_UPDATE_INTRO = 'Ежедневный матч против нейросети ';
export const TEXT_AI_MATCH_NEWS_UPDATE_INTRO_END = ' от Anthropic теперь начинается в другое время.';

export const TEXT_AI_MATCH_JOIN_ERROR_TITLE = 'Не удалось присоединиться';
export const TEXT_AI_MATCH_JOIN_AUTH_REQUIRED = 'Войдите в аккаунт заново, чтобы присоединиться';
export const TEXT_AI_MATCH_JOIN_PHASE_STARTED =
  'Матч с AI уже начинается — новых игроков в него больше не принимают.';
export const TEXT_AI_MATCH_JOIN_LOBBY_FULL = 'Все места в матче с AI уже заняты.';
export const TEXT_AI_MATCH_JOIN_LOBBY_CLOSED = 'Лобби матча с AI уже закрыто.';
export const TEXT_AI_MATCH_JOIN_NETWORK_ERROR =
  'Не удалось связаться с сервером. Проверьте подключение к интернету и попробуйте еще раз.';
export const TEXT_AI_MATCH_JOIN_FAILED = 'Не удалось присоединиться к матчу с AI. Попробуйте еще раз.';

// Модалка входа зрителем в ИИ-лобби (AiLobbySpectatorModal): лобби было
// полным — или мест еще хватало, но набор уже закрыт (баны, выбор фракций)
export const TEXT_AI_LOBBY_SPECTATOR_FULL_TITLE = 'Лобби заполнено';
export const TEXT_AI_LOBBY_SPECTATOR_FULL_TEXT = 'Все места в лобби уже заняты, вы подключены в режиме зрителя';
export const TEXT_AI_LOBBY_SPECTATOR_PHASE_STARTED_TITLE = 'Матч уже начинается';
export const TEXT_AI_LOBBY_SPECTATOR_PHASE_STARTED_TEXT = 'Набор игроков закрыт — вы подключены в режиме зрителя';

// Тосты сокета ИИ-лобби (LobbyPage): сервер не признал вход (AUTH_REQUIRED)
// и сервер отменил матч дня (LOBBY_CLOSED с причиной AI_PROMO_CANCELLED)
export const TEXT_AI_LOBBY_AUTH_REQUIRED = 'Войдите в аккаунт заново';
export const TEXT_AI_MATCH_CANCELLED_TODAY = 'Битва с ИИ на сегодня отменена';
